import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../../src/util/install_sentry'
import '../../src/refosumu/reform_db/chart_for_contracted_construction_price_range'
import '../../src/refosumu/reform_db/chart_for_contracted_part_type_distribution_chart'

import './site_common'

import 'Components/refosumu/company_show/component'
import 'Components/refosumu/company_show/inquiry_cta/component'

import 'Components/refosumu/basics/breadcrumb/component'
import 'Components/refosumu/reason_points/component'
import 'Components/refosumu/company_card/component'
import 'Components/refosumu/example_card/component'
import 'Components/refosumu/carousel_light/component'
import 'Components/refosumu/review_card/component'
import 'Components/refosumu/call_to_action_button/component'
import 'Components/refosumu/call_to_action_link/component'
import 'Components/refosumu/v2/floating/component'
import 'Components/refosumu/shared/company_reform_areas/component'

import spToggleNav from '../../src/spToggleNav/spToggleNav'

$(() => {
  spToggleNav()
})

const chart = require('chart.js')
